var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-expense-add'},"title":'ការចំណាយ'}}),_c('List',{attrs:{"dataList":_vm.data,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[ 
          {name: 'amount', type: 'currency'},
          {name: 'cash_amount', type: 'currency'},
          {name: 'bank_amount', type: 'currency'},
          {name: 'cheque_amount', type: 'currency'},
          {name: 'expense_date', type: 'date'}
        ],"fields":[ 
          "code: លេខកូដ",
          "expense_date: កាលបរិច្ឆេទ",
          "category_name: មុខចំណាយ",
          "amount: ចំណាយសរុប",
          "cash_amount: តាមសាច់ប្រាក់",
          "bank_amount: តាមធនាគារ",
          "cheque_amount: សែក" ],"deletes":[_vm.deleted, null],"edit":{link: 'manage-expense-edit'},"filter":{
          search: ['manage_expenses.name','manage_expenses.code'],
          dropdown: [{
            title: 'manage.expense-category.text',
            field: 'manage_expenses.expense_category_id',
            data: this.categoryData.data,
          }]
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }